var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "py-4 login-view-container mx-auto" }, [
    _c(
      "div",
      { staticClass: "login-view" },
      [
        _c("h1", { staticClass: "login-view-title mb-4" }, [
          _vm._v(_vm._s(_vm.multiLanguage.LoginTitle)),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "login-container" },
          [
            _c("login", {
              attrs: {
                backlink: _vm.sanitizedBacklink,
                "has-to-forward": true,
                "multi-language": _vm.multiLanguage,
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "extend-overlay-buttons",
                    fn: function () {
                      return [_vm._t("extend-overlay-buttons")]
                    },
                    proxy: true,
                  },
                ],
                null,
                true
              ),
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "register-container" }, [
          _c("h3", [_vm._v(_vm._s(_vm.multiLanguage.LoginSubTitle))]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "\n        " + _vm._s(_vm.multiLanguage.LoginText) + "\n      "
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "register-buttons" }, [
            _c("div", [
              _c("a", { attrs: { href: _vm.registrationUrl } }, [
                _c(
                  "button",
                  { staticClass: "btn btn-primary btn-block mb-3" },
                  [
                    _c(
                      "svg",
                      {
                        attrs: {
                          width: "18",
                          height: "18",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          xmlns: "http://www.w3.org/2000/svg",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            d: "M3 20C5.33579 17.5226 8.50702 16 12 16C15.493 16 18.6642 17.5226 21 20M16.5 7.5C16.5 9.98528 14.4853 12 12 12C9.51472 12 7.5 9.98528 7.5 7.5C7.5 5.01472 9.51472 3 12 3C14.4853 3 16.5 5.01472 16.5 7.5Z",
                            stroke: "white",
                            "stroke-width": "1.5",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                          },
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(_vm._s(_vm.multiLanguage.LoginButton1)),
                    ]),
                  ]
                ),
              ]),
            ]),
            _vm._v(" "),
            !_vm.myAccountInBacklink
              ? _c("div", [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary btn-block mb-3",
                      on: {
                        click: function ($event) {
                          return _vm.openGuestModal()
                        },
                      },
                    },
                    [
                      _c(
                        "svg",
                        {
                          attrs: {
                            width: "18",
                            height: "18",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                          },
                        },
                        [
                          _c("path", {
                            attrs: {
                              d: "M5.00014 14H18.1359C19.1487 14 19.6551 14 20.0582 13.8112C20.4134 13.6448 20.7118 13.3777 20.9163 13.0432C21.1485 12.6633 21.2044 12.16 21.3163 11.1534L21.9013 5.88835C21.9355 5.58088 21.9525 5.42715 21.9031 5.30816C21.8597 5.20366 21.7821 5.11697 21.683 5.06228C21.5702 5 21.4155 5 21.1062 5H4.50014M2 2H3.24844C3.51306 2 3.64537 2 3.74889 2.05032C3.84002 2.09463 3.91554 2.16557 3.96544 2.25376C4.02212 2.35394 4.03037 2.48599 4.04688 2.7501L4.95312 17.2499C4.96963 17.514 4.97788 17.6461 5.03456 17.7462C5.08446 17.8344 5.15998 17.9054 5.25111 17.9497C5.35463 18 5.48694 18 5.75156 18H19M7.5 21.5H7.51M16.5 21.5H16.51M8 21.5C8 21.7761 7.77614 22 7.5 22C7.22386 22 7 21.7761 7 21.5C7 21.2239 7.22386 21 7.5 21C7.77614 21 8 21.2239 8 21.5ZM17 21.5C17 21.7761 16.7761 22 16.5 22C16.2239 22 16 21.7761 16 21.5C16 21.2239 16.2239 21 16.5 21C16.7761 21 17 21.2239 17 21.5Z",
                              stroke: "#fff",
                              "stroke-width": "1.5",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                            },
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(_vm._s(_vm.multiLanguage.LoginButton2)),
                      ]),
                    ]
                  ),
                ])
              : _vm._e(),
          ]),
        ]),
        _vm._v(" "),
        _vm._t("additional-content-after-buttons"),
      ],
      2
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        ref: "guestModal",
        staticClass: "modal fade",
        attrs: { tabindex: "-1", role: "dialog" },
      },
      [
        _c("div", { staticClass: "modal-dialog modal-dialog-centered px-3" }, [
          _c("div", { staticClass: "modal-content" }, [
            _c("div", { staticClass: "modal-header" }, [
              _c("div", { staticClass: "modal-title h3" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(
                      _vm.$translate("Ceres::Template.loginOrderAsGuest")
                    ) +
                    "\n          "
                ),
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "close",
                  attrs: {
                    type: "button",
                    "data-testing": "guest-login-modal",
                    "data-dismiss": "modal",
                    "aria-hidden": "true",
                    "aria-label": _vm.$translate("Ceres::Template.closeIcon"),
                  },
                },
                [
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "30",
                        height: "30",
                        viewBox: "0 0 40 40",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                      },
                    },
                    [
                      _c("rect", {
                        attrs: {
                          width: "40",
                          height: "40",
                          rx: "20",
                          fill: "white",
                          "fill-opacity": "0.68",
                        },
                      }),
                      _vm._v(" "),
                      _c("path", {
                        attrs: {
                          d: "M28.3332 11.667L11.6665 28.3337M11.6665 11.667L28.3332 28.3337",
                          stroke: "#090909",
                          "stroke-width": "1.66667",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                        },
                      }),
                    ]
                  ),
                ]
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "modal-body" },
              [
                _c("guest-login", {
                  attrs: {
                    backlink: _vm.sanitizedBacklink,
                    "initial-email": _vm.guestEmail,
                    "multi-language": _vm.multiLanguage,
                  },
                }),
              ],
              1
            ),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }